import { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import { api } from "@/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const NotifCtx = createContext(null);

export function NotificationsProvider({ children }) {
    const { user } = useAuth();
    const [items, setItems] = useState([]);
    const [unread, setUnread] = useState(0);
    const prevUnreadRef = useRef(0);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/notifications");
            setItems(data);
            const u = data.filter(n => !n.read).length;
            if (u > prevUnreadRef.current && prevUnreadRef.current > 0) {
                const latest = data.find(n => !n.read);
                if (latest) toast(latest.message);
            }
            prevUnreadRef.current = u;
            setUnread(u);
        } catch { /* ignore */ }
    }, []);

    useEffect(() => {
        if (!user || user === false) {
            setItems([]); setUnread(0); prevUnreadRef.current = 0;
            return;
        }
        load();
        const t = setInterval(load, 20000);
        return () => clearInterval(t);
    }, [user, load]);

    const markRead = async (id) => {
        try {
            await api.post(`/notifications/${id}/read`);
            setItems(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
            setUnread(u => Math.max(0, u - 1));
        } catch { /* ignore */ }
    };

    const markAllRead = async () => {
        try {
            await api.post("/notifications/mark-all-read");
            setItems(prev => prev.map(n => ({ ...n, read: true })));
            setUnread(0);
        } catch { /* ignore */ }
    };

    return (
        <NotifCtx.Provider value={{ items, unread, load, markRead, markAllRead }}>
            {children}
        </NotifCtx.Provider>
    );
}

export const useNotifications = () => useContext(NotifCtx);
